export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONValue[]
  | { [key: string]: JSONValue };

export const FAILED_NETWORK_HTTP_STATUS = 0;

export class ResponseError<T = JSONValue> extends Error {
  status: number;
  data: T;
  headers: Headers;

  constructor(url: string, status: number, data: T, headers: Headers) {
    super(`Network request to ${url} failed with status ${status}`);

    this.status = status;
    this.data = data;
    this.headers = headers;
  }
}

async function buildResponseError(response: Response): Promise<ResponseError> {
  try {
    const data = (await response.json()) as JSONValue;

    return new ResponseError(
      response.url,
      response.status,
      data,
      response.headers,
    );
  } catch (_e) {
    return new ResponseError(
      response.url,
      response.status,
      null,
      response.headers,
    );
  }
}

export async function raisableFetch(
  url: string | RequestInfo | URL,
  input: RequestInit | undefined,
): Promise<Response> {
  const request = fetch(url, input);

  try {
    await request;
  } catch (_e) {
    throw new ResponseError(
      url as string,
      FAILED_NETWORK_HTTP_STATUS,
      null,
      new Headers(),
    );
  }

  const response = await request;

  if (!response.ok) {
    throw await buildResponseError(response);
  }

  return request;
}
